import React, { Component } from 'react';

export default class LoadingSpinner extends Component {
  render() {
    const { className } = this.props;
    return <span className={`loader ${className ? className : ''}`}></span>;
  }
}